// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Wt4t","addWidgetButton":"Header_addWidgetButton__OhDcQ","dashboardTabs":"Header_dashboardTabs__1klGq","active":"Header_active__1ldk2"};